import Button, { ButtonProps } from '@carvana/ds-button';
import { AnalyticsAttributes } from '@carvana/merch-components/contracts';
import { useIsMobile } from '~/context/common/DeviceContext';

type OwnProps = ButtonProps & {
  'data-adobe-id': string | null;
  'data-analytics-id': string | null;
  'data-analytics-attributes'?: AnalyticsAttributes;
  'data-testid'?: string;
  href: string;
  text: string;
};

export default function DealershipCtaButton({
  'data-adobe-id': adobeId,
  'data-analytics-id': analyticsId,
  'data-analytics-attributes': analyticsAttributes,
  'data-testid': testId,
  href,
  text,
  ...rest
}: OwnProps) {
  const isMobile = useIsMobile();

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-adobe-id={adobeId}
      data-analytics-id={analyticsId}
      data-analytics-attributes={JSON.stringify({
        ...(analyticsAttributes ?? {}),
        text
      })}
      data-testid={testId}
    >
      <Button size={isMobile ? 'md' : 'lg'} width="100%" {...rest}>
        {text}
      </Button>
    </a>
  );
}
